<template>
  <div
    v-if="allowed"
    class="my-5 md:my-15 2xl:my-20"
  >
    <h3 class="mb-15 2xl:mb-20 w-full">
      Dépôt de documents
    </h3>

    <root-folder
      v-if="path.length === 0 && (folders.length > 0 || files.length > 0)"
      :folders="folders"
      :files="files"
      :color-by-type="colorByType"
      @openFolder="(folder) => {addFolderToPath(folder);} "
      @displayAllFiles="displayAllFiles()"
    />

    <recent-files
      v-if="path[0] === 'allFiles'"
      :files="files"
      :folders="folders"
      :color-by-type="colorByType"
      @goto="(index) => { goToPath(index);}"
    />

    <current-folder
      v-if="path.length > 0 && path[0] !== 'allFiles'"
      :path="path"
      :files="files"
      :folders="folders"
      @openFolder="(folder) => {addFolderToPath(folder);} "
      @goto="(index) => { goToPath(index);}"
    />

    <no-file-found
      v-if="path.length === 0 && folders.length === 0 && files.length === 0"
    />
  </div>
  <page-not-allowed v-else />
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import Illustration from './../../../components/Illustration';
import AddButton from './../../../components/Inputs/AddButton';
import FolderCard from  './../../../components/DepotDocuments/FolderCard';
import Tag from './../../../components/Tag';
import ListAvatars from './../../../components/ListAvatars';
import Icon from './../../../components/Icon';
import RootFolder from './../../depotDocuments/RootFolder';
import CurrentFolder from './../../depotDocuments/CurrentFolder';
import RecentFiles from './../../depotDocuments/RecentFiles';
import MessageHeader from '../../../components/MessageHeader';
import PageNotAllowed from './../../../components/PageNotAllowed.vue';
import NoFileFound from './../../depotDocuments/NofileFound';

export default {
  name:'Documents',

  components:{
    MessageHeader,
    Illustration,
    AddButton,
    FolderCard,
    Tag,
    ListAvatars,
    Icon,
    RootFolder,
    CurrentFolder,
    RecentFiles,
    PageNotAllowed,
    NoFileFound,
  },

  data(){
    return {
      path: [],

      colorByType:{
        'jpeg': 'teal',
        'jpg': 'teal',
        'gif': 'teal',
        'bmp': 'teal',
        'heic': 'teal',
        'heif': 'teal',
        'png': 'teal',
        'doc': 'pink',
        'docx': 'pink',
        'pdf': 'indigo',
      },
    };
  },

  mounted(){
    //this.generateRawDatas(6, 50);
  },

  methods:{
    generateRawDatas(nbCreatedFolders, nbCreatedFiles){

      let collaborators = [
        {firstname:'David', lastname:'Chhang', urlAvatar:''},
        {firstname:'Fabrice', lastname:'Autissier', urlAvatar:''},
        {firstname:'Inès', lastname:'Atallah', urlAvatar:''},
        {firstname:'Aurélien', lastname:'Bouvaist', urlAvatar:''},
        {firstname:'Mélanie', lastname:'Beffre', urlAvatar:''},
        {firstname:'Karine', lastname:'Meyer', urlAvatar:''}
      ];

      //Some folders
      let folderNames = ['Règlements', 'Chartes', 'Registres', 'Comptes-rendus', 'Synthèses', 'Tableaux', 'Lorem Ipsum', 'Surveillance', 'Fragile'];
      let themes = ['indigo', 'pink', 'gray', 'teal', 'orange'];

      /* for (let index = 0; index < nbCreatedFolders; index++) {

                let foldername = folderNames[(Math.floor(Math.random() * folderNames.length))];
                let themeColor = themes[(Math.floor(Math.random() * themes.length))];

                let listCollaborators = [];

                for (let j = 0; j < (Math.floor(Math.random() * 5)); j++) {
                    listCollaborators.push(collaborators[j]);
                }

                this.folders.push({
                    id:(index+1),
                    folderId: null,
                    name: foldername,
                    themeColor: themeColor,
                    nbFiles: (Math.floor(Math.random() * 100)),
                    createdDate: new Date(),
                    sharedWith: listCollaborators,
                });
            } */

      //Some files

      let fileType = ['PDF', 'DOC', 'JPG'];

      for (let index = 0; index < nbCreatedFiles; index++) {
        let type = fileType[(Math.floor(Math.random() * fileType.length))];
        //let parentFolder = this.folders[(Math.floor(Math.random() * this.folders.length))];

        let colorTheme = 'default';

        switch (type) {
        case 'PDF':
          colorTheme = 'indigo';
          break;
        case 'DOC':
          colorTheme = 'pink';
          break;
        case 'JPG':
          colorTheme = 'teal';
          break;
        default:
          colorTheme = 'default';
          break;
        }

        let listCollaborators = [];

        for (let j = 0; j < (Math.floor(Math.random() * 5)); j++) {
          listCollaborators.push(collaborators[j]);
        }

        this.files.push({
          id:(index+1),
          folderId: 1,
          type: type,
          colorTheme: colorTheme,
          name: 'Fichier n°'+(index+1),
          parentFolder: 'Test',
          sharedWith: listCollaborators,
          createdDate: new Date('01/01/2020'),
        });
      }
    },

    addFolderToPath(folder){
      this.path.push(folder);
    },

    displayAllFiles(){
      this.path = ['allFiles'];
    },

    goToPath(pos){
      if(pos === null){
        this.path = [];
        return;
      }

      this.path = this.path.filter((p, i) => i<=pos);
    }
  },

  computed:{
    ...mapGetters({
      folders:'depotDocuments/folders',
      files:'depotDocuments/files',
      messageHeader:'depotDocuments/messageHeader',
      allowed: 'app/allowed',
    }),
  }
};
</script>
